import Vue from "vue";
import Router from "vue-router";
import { isStoreReady, getStore } from '../store'; // Adjust path as needed
import { login } from "../middlewares";
import middlewares from "../middlewares";

Vue.use(Router);

import dashboardRoutes from "./dashboard";
import internalMessaging from "./internal-messaging";
import mapRoutes from "./maps";
import collectionsRoutes from "./collections";
import returnsRoutes from "./returns";
import productMapRoutes from "./product_maps";

export default new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
});

function configRoutes() {
  return [
    {
      path: "/dashboard",
      name: "Dashboard",
      redirect: "/"
    },
    {
      path: "/",
      name: "Home",
      redirect: "/dashboards/main",
      // component: () => import("../containers/TheContainer.vue"),
      component: () => import("../containers/TheContainer.vue"),
      meta: { title: "Home" },
      children: [
        ...dashboardRoutes,
        ...mapRoutes,
        ...internalMessaging,
        ...collectionsRoutes,
        ...returnsRoutes,
        ...productMapRoutes,
        {
          path: "admin",
          name: "Admin Panel",
          meta: { title: "Admin", requiresAdmin: true },
          beforeEnter: (to, from, next) => {
            // use adminOnly middleware
            const store = isStoreReady() ? getStore() : null
            if (!store) return next({ name: 'Login' })
            return middlewares.adminOnly(store)(to, from, next)
          },
          component: () => import("../views/admin/Index.vue")
        },
        {
          path: "admin/ai-analytics",
          name: "AI Analytics",
          meta: { title: "AI Analytics", requiresAdmin: true },
          beforeEnter: (to, from, next) => {
            // use adminOnly middleware
            const store = isStoreReady() ? getStore() : null
            if (!store) return next({ name: 'Login' })
            return middlewares.adminOnly(store)(to, from, next)
          },
          component: () => import("../views/admin/AIAnalyticsDashboard.vue")
        },
        {
          path: "admin/knowledge-base",
          name: "Knowledge Base Manager",
          meta: { title: "Knowledge Base", requiresAdmin: true },
          beforeEnter: (to, from, next) => {
            // use adminOnly middleware
            const store = isStoreReady() ? getStore() : null
            if (!store) return next({ name: 'Login' })
            return middlewares.adminOnly(store)(to, from, next)
          },
          component: () => import("../views/admin/KnowledgeBaseManager.vue")
        },
        {
          path: "admin/slow-query-analyzer",
          name: "Slow Query Analyzer",
          meta: { title: "Slow Query Analyzer", requiresAdmin: true },
          beforeEnter: (to, from, next) => {
            // use adminOnly middleware
            const store = isStoreReady() ? getStore() : null
            if (!store) return next({ name: 'Login' })
            return middlewares.adminOnly(store)(to, from, next)
          },
          component: () => import("../views/admin/SlowQueryAnalyzer.vue")
        },
        {
          path: "admin/login-verifications",
          name: "Login Verifications",
          meta: { title: "Login Verifications", requiresAdmin: true },
          beforeEnter: (to, from, next) => {
            const store = isStoreReady() ? getStore() : null
            if (!store) return next({ name: 'Login' })
            return middlewares.adminOnly(store)(to, from, next)
          },
          component: () => import("../views/admin/LoginVerifications.vue")
        }
      ]
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: () => import("../views/pages/Page404.vue")
        },
        {
          path: "500",
          name: "Page500",
          component: () => import("../views/pages/Page500")
        }
      ]
    },
    {
      path: "/",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "login",
          name: "Login",
          meta: { permission: "login" },
          beforeEnter: async (to, from, next) => {
            let store;

            if (isStoreReady()) {
              store = getStore();
            }
            if (!store.getters['authentication/isAuthenticated']) {
              next()
            } else {
              next({ name: 'Main Dashboard' })
            }
          },
          component: () => import("../views/pages/Login")
        },
        {
          path: "register",
          name: "Register",
          component: () => import("../views/pages/Register")
        }
      ]
    },
    {
      path: "*",
      name: "404",
      component: () => import("../views/pages/Page404.vue")
    }
  ];
}
